import React from 'react';
import { ScoreResult } from '../types';

interface ScoreDisplayProps {
  result: ScoreResult;
}

const ScoreDisplay: React.FC<ScoreDisplayProps> = ({ result }) => (
  <aside className={`score-panel score-panel--${result.tone}`} aria-live="polite">
    <div className="score-panel__summary">
      <span className="score-panel__summary-label">NEWS2 bendra suma</span>
      <strong>{result.total}</strong>
      <div className="score-panel__summary-risk">{result.riskLevel} rizika</div>
    </div>

    <div className="score-panel__details">
      <section>
        <h2>Stebėjimo dažnumas</h2>
        <p className="score-panel__value">{result.frequencyOfMonitoring}</p>
      </section>
      <section>
        <h2>Klinikinis atsakas</h2>
        <p className="score-panel__value">{result.clinicalResponse}</p>
      </section>
    </div>
  </aside>
);

export default ScoreDisplay;
